<template>
  <div class="agents-tradesmanlist">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入关键词查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <!-- <FormItem>
                    <Button type="success" @click="createAgentTradesMan()">新增</Button>
                </FormItem> -->
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Modal v-model="showModalStatus"
           title="添加匠人"
           @on-ok="ok"
           :width='800'>
      <Form :model="search_s"
            ref="search_s"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="search_s.key"
                 clearable
                 placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable1('search_s')">查找</Button>
        </FormItem>
      </Form>
      <Table border
             :columns="columns2"
             ref="selection"
             :data="columns2List"
             :loading="dataloading"
             @on-selection-change="handleSelectRow()"></Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page ref="listPage1"
                :total="pages1.total"
                :current="pages1.page"
                :page-size="pages1.size"
                show-elevator
                show-total
                @on-change="changePage1()"></Page>
        </div>
      </div>
    </Modal>
    <!-- 添加二维码 -->
    <Modal v-model="showCreatModal"
           title="添加二维码"
           @on-ok="createType()"
           :loading="loading">
      <Form :model="qrcodedata"
            ref="addCate"
            action="javascript:void(0)">
        <FormItem label="编号">
          <Input v-model="qrcodedata.num"
                 placeholder />
        </FormItem>
        <FormItem label="备注">
          <Input v-model="qrcodedata.mark"
                 placeholder />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb"
import uploadthumbTwo from "../common/thumb"
export default {
  name: 'agents-tradesmanlist',
  data () {
    return {
      id: null,   // 页面agentid
      loading: true,
      dataloading: true,
      showCreatModal: false,
      agenttraduuid: "",
      qrcodedata: {
        num: "",
        mark: ""
      },
      title: "",
      tablelist1: [],
      columns2: [
        {
          title: '商户ID',
          key: 'agent_uuid',
          width: 300
        },
        {
          title: '店铺名称',
          key: 'nickname',
          minWidth: 160,
          render: (h, params) => {
            return h('span', params.row.tradesman != null ? params.row.tradesman.nickname : '')
          }
        },
        {
          title: '商户电话',
          key: 'username',
          minWidth: 160,
          render: (h, params) => {
            return h('span', params.row.user != null ? params.row.user.username : '')
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          align: 'left',
          fixed: 'right',
        }
      ],
      columns2List: [],
      pages: {
        page: 1,
        size: 10
      },
      pages1: {
        page: 1,
        size: 10
      },
      search_s: {},
      formItem: {
        'key': '',
      },
      list: [
        {
          title: '商户ID',
          key: 'agent_uuid',
          width: 350
        },
        {
          title: '店铺名称',
          key: 'nickname',
          minWidth: 160,
          render: (h, params) => {
            return h('span', params.row.tradesman != null ? params.row.tradesman.nickname : '')
          }
        },
        {
          title: '商户电话',
          key: 'username',
          minWidth: 160,
          render: (h, params) => {
            return h('span', params.row.tradesman.data != null ? params.row.tradesman.data.phone : '')
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 300,
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: "8px",
                },
                props: {
                  type: 'success',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.createTradesManQrcode(params.row.trades_uuid)
                  }
                }
              }, '绑定二维码'),
              h('Button', {
                style: {
                },
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.row.agent_uuid, params.row.trades_uuid)
                  }
                }
              }, '删除')
            ]);
          }
        }

      ],
      tablelist: [],
      showModalStatus: false,
    }
  },
  created: function () {
    this.id = this.$route.params.id;
    this.getTableList();
  },
  components: {
    UploadThumb,
    uploadthumbTwo,
  },
  watch: {
    "$route.params.id": function (curVal, oldVal) {
      if (curVal) {
        this.id = curVal;
        this.getTableList();
      }
    }
  },
  methods: {
    getTableList: function () {
      this.$api.agents.agenttradesmanlist({ "page": this.pages.page, "size": this.pages.size, id: this.id }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    createTradesManQrcode: function (traduuid) {
      this.showCreatModal = true;
      this.qrcodedata.num = "";
      this.qrcodedata.mark = "";
      this.agenttraduuid = traduuid;
    },
    //修改编号
    createType: function (id) {
      this.showCreatModal = true;
      this.$api.agents.addtradqrcode({ agenttraduuid: this.agenttraduuid, num: this.qrcodedata.num, mark: this.qrcodedata.mark }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.renderTable(1);
          this.showCreatModal = false;
        }
        this.loading = false;
      });
    },
    createAgentTradesMan () {
      this.showModalStatus = true;
      this.$api.agents.createTradShowTradList({ id: this.id }).then(res => {
        if (res.code == 200) {
          this.columns2List = res.result.list;
          this.pages1.total = res.result.total;
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    },
    // 删除
    remove: function (id, trades_uuid) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.agents.tradesmanremove({ id: id, trades_uuid: trades_uuid }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    change () {

    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        id: this.id
      };
      this.$api.agents.agenttradesmanlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          for (var i in this.tablelist) {
            this.tablelist[i].phone = this.tablelist[i].data.phone;
            this.tablelist[i].auth_company = this.tablelist[i].data.auth_company;
            this.tablelist[i].is_undeline = this.tablelist[i].is_undeline == 0 ? "否" : "是";
            this.tablelist[i].cate = this.tablelist[i].cate.name;
          }
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 筛选
    renderTable1: function (name) {
      if (name != 1) {
        this.pages1.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        id: this.id
      };
      this.$api.agents.agenttradesmanlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.columns2List = res.result.list;
          for (var i in this.tablelist) {
            this.tablelist[i].phone = this.tablelist[i].data.phone;
            this.tablelist[i].auth_company = this.tablelist[i].data.auth_company;
            this.tablelist[i].is_undeline = this.tablelist[i].is_undeline == 0 ? "否" : "是";
            this.tablelist[i].cate = this.tablelist[i].cate.name;
          }
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    //选中提交
    ok () {
      this.tablelist1 = this.selected;
    },
  },
}
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
